import { computed, onMounted, onUnmounted, ref } from 'vue';

enum BREAKPOINTS {
  SMALL = 0,
  MEDIUM = 768,
  LARGE = 1200,
}

export const useResponsive = () => {
  const width = ref(window.innerWidth);
  const update = () => (width.value = window.innerWidth);

  onMounted(() => window.addEventListener('resize', update));
  onUnmounted(() => window.removeEventListener('resize', update));

  const inIframe = ref(window.self !== window.top);

  const isSmallDisplay = computed(() => width.value < BREAKPOINTS.MEDIUM);
  const isMediumDisplay = computed(
    () => width.value >= BREAKPOINTS.MEDIUM && width.value < BREAKPOINTS.LARGE,
  );
  const isLargeDisplay = computed(() => width.value >= BREAKPOINTS.LARGE);

  const maxBookingPanels = computed(() => {
    if (isLargeDisplay.value) return 3;
    if (isMediumDisplay.value) return 2;
    return 1;
  });

  return {
    width,
    inIframe,
    isSmallDisplay,
    isMediumDisplay,
    isLargeDisplay,
    maxBookingPanels,
  };
};
